module.exports = __webpack_public_path__ + "static/media/info_2.af9c3395.svg";